import * as Sentry from "@sentry/nextjs";

/**
 * Ensures that errors in `production` are handled gracefully and reported to Sentry.
 * Errors in `development` or `test` environments will still get thrown to provide user feedback.
 */
export function handleClientError(error: Error): void {
  if (process.env.NODE_ENV === "production") {
    Sentry.captureException(error);
  } else {
    throw error;
  }
}
